// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, forwardRef} from 'react';
import {Nav} from './navbar_hola2023/nav';
import {Mobile_nav} from './navbar_hola2023/mobile_nav';
import {use_navbar, use_navbar_props} from './navbar_hola2023/use_navbar';
import cn from 'classnames';
import styles from './navbar_hola2023.module.less';

export const Navbar_hola2023 = forwardRef(function _Navbar_hola2023(
    props: use_navbar_props, ref)
    {
    const opt = use_navbar(props);
    const {top_portal_ref} = ref as any;
    // XXX dmitriiz: use navbar_global_class only for temporary reason,
    // such as experiments
    const navbar_cls = cn(styles.navbar, 'navbar_global_class');
    return opt.headless ? <Fragment/> : <div
      className={navbar_cls}>
      <div className="top-portal" ref={top_portal_ref}/>
      <Nav {...opt}/>
      <Mobile_nav {...opt}/>
    </div>;
});
